import '@mantine/core/styles.css'
import '@mantine/notifications/styles.css'
import '@mantine/spotlight/styles.css'
import './styles.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Providers } from './app/providers'
import { AppErrorBoundary } from './app/error-boundary'
import { AppRouter } from './app/router'

const container = document.getElementById('root')
if (!container) throw new Error('root element missing')

createRoot(container).render(
  <StrictMode>
    <Providers>
      <AppErrorBoundary>
        <AppRouter />
      </AppErrorBoundary>
    </Providers>
  </StrictMode>,
)
